import React from 'react';
import BreakpointContent from 'src/Components/BreakpointContent';
import TableDesktop from './TableDesktop';
import TableMobile from './TableMobile';

const TableData = ({
  getTokenIdList,
  hasResetSelected,
  tokenIdsSelected,
  getTotalHeroesInventory,
  getParamsSearch,
  hasQuickSelect
}) => {
  return /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: () => /*#__PURE__*/React.createElement(TableMobile, {
      getTokenIdList: getTokenIdList,
      hasResetSelected: hasResetSelected,
      tokenIdsSelected: tokenIdsSelected,
      getTotalHeroesInventory: getTotalHeroesInventory,
      getParamsSearch: getParamsSearch,
      hasQuickSelect: hasQuickSelect
    }),
    renderTablet: () => /*#__PURE__*/React.createElement(TableDesktop, {
      getTokenIdList: getTokenIdList,
      hasResetSelected: hasResetSelected,
      tokenIdsSelected: tokenIdsSelected,
      getTotalHeroesInventory: getTotalHeroesInventory,
      getParamsSearch: getParamsSearch,
      hasQuickSelect: hasQuickSelect
    }),
    renderDesktop: () => /*#__PURE__*/React.createElement(TableDesktop, {
      getTokenIdList: getTokenIdList,
      hasResetSelected: hasResetSelected,
      tokenIdsSelected: tokenIdsSelected,
      getTotalHeroesInventory: getTotalHeroesInventory,
      getParamsSearch: getParamsSearch,
      hasQuickSelect: hasQuickSelect
    })
  });
};

export default TableData;